module.exports = __webpack_public_path__ + "static/media/german-number-20-90.dfd245fa.PNG";